import { PutTripDatesType } from '@orbit/api-types'
import { usePut } from '@hooks/useApi'
import { daysBetween, toCompact } from '@lib/datetime'
import { queryKeys } from '@lib/queryKeys'
import { useQueryClient } from '@tanstack/react-query'
import { Trip } from '@types'

interface UpdateTripDatesParams {
	startDate: string // YYYY-MM-DD format
	endDate: string // YYYY-MM-DD format
}

export const useUpdateTripDates = (tripId: string) => {
	const queryClient = useQueryClient()

	return usePut<PutTripDatesType, Trip>(`/trips/${tripId}/tripDates`, {
		onSuccess: updatedTrip => {
			queryClient.invalidateQueries({ queryKey: queryKeys.trip(tripId) })
			queryClient.invalidateQueries({ queryKey: queryKeys.trips() })
			queryClient.invalidateQueries({ queryKey: queryKeys.events(tripId) })
			queryClient.setQueryData(queryKeys.trip(tripId), updatedTrip)
		},
	})
}

// Helper function to convert date range to API payload
export const convertDateRangeToPayload = (params: UpdateTripDatesParams): PutTripDatesType => {
	// Normalize YYYY-MM-DD to the wire's compact YYYYMMDD form (UTC-stable).
	const startDate = toCompact(params.startDate)

	// Inclusive day count from start to end (UTC-stable whole-day diff + 1).
	const dayCount = daysBetween(params.startDate, params.endDate) + 1

	return {
		startDate,
		dayCount,
	}
}
